<template lang='pug' src='./custom-home-social.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      socialSection: 0,
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 24,
        centeredSlides: true,
        // autoplay: {
        //   delay: 5000
        // },
        speed: 1000,
        loop: true,
        breakpoints: {
          1279: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 32
          }
        }
      }
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  props: ['props'],
  components: {
    Icon
  },
  methods: {
    showSection (i) {
      this.socialSection = i
    },
    slidePrev () {
      this.mySwiper.slidePrev()
    },
    slideNext () {
      this.mySwiper.slideNext()
    }
  }
}

</script>



// WEBPACK FOOTER //
// custom-home-social.vue?69ff0707